var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.19 1.70263C18.1142 2.18946 18.0004 2.6763 17.8993 3.15681C17.1031 6.89342 16.3131 10.63 15.5169 14.3666C15.2894 15.4478 14.7016 15.6628 13.8043 15.0052C12.6162 14.1327 11.4345 13.2539 10.2464 12.375C10.1642 12.3118 10.0758 12.2549 9.98096 12.1917C9.29845 12.8556 8.62858 13.5068 7.95239 14.158C7.76281 14.3413 7.55426 14.4994 7.23828 14.4488C7.28252 13.7217 7.32676 13.0136 7.37731 12.2992C7.41523 11.7428 7.44051 11.1864 7.49739 10.63C7.51002 10.4783 7.58586 10.3013 7.69329 10.2001C10.0758 8.03147 12.4709 5.87549 14.866 3.71319C14.9734 3.61835 15.0619 3.50455 15.1693 3.39074C14.9039 3.16945 14.689 3.30855 14.5057 3.41603C14.0507 3.68158 13.6147 3.97241 13.166 4.25693C10.6192 5.86285 8.07246 7.46877 5.53201 9.08101C5.33611 9.20746 5.17812 9.23275 4.95062 9.1632C3.73095 8.77121 2.50496 8.39818 1.27897 8.01251C1.00091 7.92399 0.665977 7.83547 0.640699 7.48774C0.615421 7.14 0.906119 6.96929 1.17786 6.85548C2.26482 6.40026 3.37705 5.97033 4.48297 5.5404C8.60962 3.94712 12.7426 2.35385 16.8692 0.760574C16.9072 0.747929 16.9514 0.735284 16.9893 0.716316C17.7666 0.42548 18.3227 0.868057 18.19 1.70263Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c1cca6515916d5fb4fc252e46af202dc.svg";
export { ForwardRef as ReactComponent };